import React from 'react';

import { useStyledTheme } from 'hooks/useStyledTheme';

import SvgIcon from '../SvgIcon';

const IconOnlineForms = (props: React.SVGAttributes<SVGSVGElement>) => {
  const theme = useStyledTheme();

  return (
    <SvgIcon viewBox="0 0 557.4 496.9" {...props}>
      <path fill="#fff" d="M38.3 50.2h502.8v31.9H38.3z" />
      <path fill="#c2d2da" d="M542.6 83.6H36.8V48.7h505.8v34.9zm-502.8-3h499.8V51.7H39.8v28.9z" />
      <path fill="#e5ebed" d="M38.3 82.1h502.8V388H38.3z" />
      <path fill="#c2d2da" d="M542.6 389.6H36.8v-309h505.8v309zm-502.8-3h499.8v-303H39.8v303z" />
      <circle fill="#c2d2da" cx="61.5" cy="66.3" r="4.1" />
      <circle fill="#c2d2da" cx="77.9" cy="66.3" r="4.1" />
      <circle fill="#c2d2da" cx="94.3" cy="66.3" r="4.1" />
      <circle fill="#c2d2da" cx="90.1" cy="143.5" r="21.8" />
      <ellipse fill="#e5ebed" cx="378.9" cy="477.1" rx="104" ry="6" />
      <ellipse fill="#e5ebed" cx="57.4" cy="448.7" rx="48.8" ry="6" />
      <path
        fill="#dae4e7"
        d="M64.1 183.4h52v11.3h-52zm102.4-48.5h67.4v17.2h-67.4zM166.47 307.51v-47.9h11.6v47.9zM188.92 307.5v-71.2h11.6v71.2zM233.71 307.46v-83.3h11.6v83.3zM256.18 307.52v-90.8h11.6v90.8zM211.3 307.44v-59.3h11.6v59.3zM256.5 134.9h67.4v17.2h-67.4zm90 0h67.4v17.2h-67.4zM64.1 211h52v11.3h-52zm0 27.7h52V250h-52z"
      />
      <path fill="#dee9ef" d="M336 147.7h169.5v212.8H336z" />
      <path
        fill={theme.colors.fountainBlue}
        d="M507 362H334.5V146.2H507V362zm-169.5-3H504V149.2H337.5V359z"
      />
      <path fill="#dae4e7" d="M142.3 82.1h3V388h-3z" />
      <circle fill="#fff" cx="166.6" cy="61.6" r="47.8" />
      <path
        fill={theme.colors.fountainBlue}
        d="M166.6 110.9c-27.2 0-49.3-22.1-49.3-49.3 0-27.2 22.1-49.3 49.3-49.3 27.2 0 49.3 22.1 49.3 49.3 0 27.2-22.1 49.3-49.3 49.3zm0-95.6c-25.5 0-46.3 20.8-46.3 46.3s20.8 46.3 46.3 46.3 46.3-20.8 46.3-46.3-20.8-46.3-46.3-46.3z"
      />
      <path
        fill={theme.colors.fountainBlue}
        d="M155.3 75.1v-2l3.7-.9V62h-3.7v-3.1h3.7v-4.8c0-3.4.9-6 2.8-7.9 1.8-1.8 4.1-2.7 7-2.7 3.9 0 7 1.6 9.5 4.8l-2.7 2.1c-1-1.2-2-2.1-3-2.7-1-.6-2.3-.9-3.8-.9-1.7 0-3.2.5-4.3 1.6-1.3 1.2-1.9 3.1-1.9 5.7v4.8H175V62h-12.4v10h15.7v3.1h-23z"
      />
      <path fill="#fff" d="M274.8 173.4h208.1v244.5H274.8z" />
      <path
        fill={theme.colors.accent}
        d="M484.4 419.5H273.3V171.9h211.1v247.6zm-208.1-3h205.1V174.9H276.3v241.6z"
      />
      <path fill={theme.colors.accent} d="M297.3 198h76v7.5h-76z" />
      <path fill="#fff" d="M297.3 227h145v22h-145z" />
      <path
        fill={theme.colors.accent}
        d="M443.8 250.5h-148v-25h148v25zm-145-3h142v-19h-142v19zM297.3 368h76v22h-76z"
      />
      <path fill="#fff" d="M297.3 266.6h145v85h-145z" />
      <path
        fill={theme.colors.accent}
        d="M443.8 353h-148v-88h148v88zm-145-3h142v-82h-142v82zM307.8 236.2h44.7v3h-44.7z"
      />
      <path fill={theme.colors.accent} d="M307.8 279.9h84v3h-84z" />
      <path
        fill="#fff"
        d="M84.8 400.1l-27.4 18.7-26-18.6a44.78 44.78 0 0 1-18.7-36.4V311l44.7-17 46.9 17v52.2c0 14.8-7.3 28.6-19.5 36.9z"
      />
      <path
        fill={theme.colors.fountainBlue}
        d="M57.4 420.7l-26.9-19.2a46.34 46.34 0 0 1-19.3-37.6V310l46.2-17.6 48.4 17.5v53.2c0 15.3-7.5 29.6-20.2 38.2l-28.2 19.4zM14.2 312v51.8c0 13.9 6.8 27.1 18.1 35.2l25.2 18L84 398.9a43.3 43.3 0 0 0 18.9-35.7v-51.1l-45.4-16.5L14.2 312z"
      />
      <circle fill="#c2d2da" cx="58.5" cy="353" r="21.8" />
      <path fill="#fff" d="M55.8 362.6l-10.3-9.2 2-2.3 8.2 7.3 13.7-13.9 2.2 2.1z" />
    </SvgIcon>
  );
};

export default IconOnlineForms;
